var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAqaLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    fill: "#fff",
    d: "m16,31a3.9,3.9 0 0 1 -1.92,-0.5l-10.18,-5.67a3.63,3.63 0 0 1 -1.9,-3.16l0,-11.35a3.64,3.64 0 0 1 1.89,-3.15l10.19,-5.68a4,4 0 0 1 1.92,-0.49a3.91,3.91 0 0 1 1.93,0.5l10.17,5.67a3.63,3.63 0 0 1 1.9,3.16l0,11.35a3.64,3.64 0 0 1 -1.89,3.15l-10.19,5.68a4,4 0 0 1 -1.92,0.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    fill: "#04A6FC",
    d: "m16,2a2.92,2.92 0 0 1 1.42,0.37l10.2,5.68a2.64,2.64 0 0 1 1.38,2.27l0,11.34a2.66,2.66 0 0 1 -1.38,2.34l-10.18,5.63a3,3 0 0 1 -1.44,0.37a3,3 0 0 1 -1.43,-0.37l-10.2,-5.63a2.64,2.64 0 0 1 -1.37,-2.32l0,-11.34a2.66,2.66 0 0 1 1.38,-2.34l10.18,-5.63a3,3 0 0 1 1.44,-0.37l0,0m0,-2l0,0a4.93,4.93 0 0 0 -2.4,0.62l-10.19,5.68a4.62,4.62 0 0 0 -2.41,4l0,11.38a4.62,4.62 0 0 0 2.41,4l10.18,5.68a5,5 0 0 0 4.82,0l10.18,-5.66a4.62,4.62 0 0 0 2.41,-4l0,-11.38a4.62,4.62 0 0 0 -2.41,-4l-10.18,-5.7a4.93,4.93 0 0 0 -2.41,-0.62z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    className: "ci-primary",
    d: "m23.15001,10l-10.76667,0a0.85,0.65 0 0 0 -0.85,0.65l0,8.23335a0.85,0.65 0 0 0 0.85,0.65l10.76667,0a0.85,0.65 0 0 0 0.84999,-0.65l0,-8.23335a0.85,0.65 0 0 0 -0.84999,-0.65zm-0.28334,8.66668l-10.2,0l0,-7.80001l10.2,0l0,7.80001z",
    fill: "#04A6FC"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    className: "ci-primary",
    d: "m10.4,20.40002l0,-8.66668l-1.13334,0l0,8.88335a0.85,0.65 0 0 0 0.85,0.65l11.61667,0l0,-0.86667l-11.33333,0z",
    fill: "#04A6FC"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    className: "ci-primary",
    d: "m8.13333,22.13335l0,-8.66667l-1.13333,0l0,8.88334a0.85,0.65 0 0 0 0.85,0.65001l11.61667,0l0,-0.86668l-11.33334,0z",
    fill: "#04A6FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAqaLibrary);
export default __webpack_public_path__ + "static/media/Aqa_Library.339f1064b7c9245112ad04b43e807ca2.svg";
export { ForwardRef as ReactComponent };